import React from "react"
import ScrollAnimation from "react-animate-on-scroll"
import HeroContent from "./hero-content"
import HeroImgDesktop from "./pricing-img-desktop"
import HeroImgMobile from "./pricing-img-mobile"
import PricingPageStyle from "./pricing-page.module.scss"

const Hero = () => (
    <div className={PricingPageStyle.heroDiv}>
        <ScrollAnimation className="fadeIn" animateOnce={true} duration={2}>
            <HeroImgDesktop />
            <HeroImgMobile />
        </ScrollAnimation>
        <HeroContent />
    </div>
)

export default Hero